/* eslint-disable no-nested-ternary */
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const AIInventoryWrapper = (): ReactElement => <Outlet />;

export default AIInventoryWrapper;
